import { FunctionComponent } from 'react';
import { ID } from '../../types/api/ID';
import { useDragAndDrop } from '.';
import { useSortableListContext } from './SortableListContext';

export function useDraggableListItem<T extends ID>(props: T, Component: FunctionComponent<T>) {
  const { move, submit } = useSortableListContext();

  const { isDragging, onDragStart, onDragEnter, onDragOver, onDragEnd } = useDragAndDrop(
    props.id,
    move,
    Component,
    props,
    submit,
  );
  const getListItemProps = () => ({
    onDragStart,
    onDragEnter,
    onDragOver,
    onDragEnd,
    draggable: true,
  });
  return { isDragging, getListItemProps };
}
